import $ from 'jquery';
import skipLinks from './utils/skipLinks';
import iframer from './utils/iframer';
// import closeNotification from './utils/closeNotification';
import mNav from './utils/mNav';
import multiNav from './utils/multiNav';
// import childTabIndex from './utils/childTabIndex';
// import searchExpand from './utils/searchExpand';
// import setupSharing from './utils/social';
// import equalHeight from './utils/equalHeight';
// import listShowHide from './utils/listShowHide';
// import googleMaps from './utils/googleMaps';
import gettingHereMaps from './utils/gettingHereMaps';
import showHideLunch from './utils/showHideLunch';
import openingTimes from './utils/openingTimes';
import showMessages from './utils/showMessages';
import storyTimeline from './utils/storyTimeline';
import slickCarousel from './utils/slickCarousel';
import datePicker from './utils/datePicker';
// import removeNovalidate from './utils/removeNovalidate';

// import cookies from './utils/cookies';
// import modalVideo from './utils/modalVideo';
// import shareURL from './utils/shareURL';
// import scrolled from './utils/scrolled';
// import topButton from './utils/topButton';

function globals () {

	// scrolled('scrolled','header');

	// topButton('topbutton');

    // modalVideo
    // modalVideo('buttonPlay','modal','modalClose');
    // modalVideo('#buttonPlay','#modal','#modalClose');

    // Cookie bar
    // cookies();

    // iframe video in body content
    iframer();

    // Small Screen Navigation
    mNav(
        '#navigation-toggle',
        'navigation-toggle--open',
        '#navigation-primary__items',
        'navigation-primary__items--open'
    );

    // Multi Navigation
    multiNav(
        '#navigation-primary',
    );

    // Highlight
    // trigger, triggerActive, target, targetActive
    mNav(
        '.highlight__trigger',
        'highlight__trigger--active',
        '.navigation-sidebar',
        'navigation-sidebar--open'
    );

    // Set child tab index for nav
    // childTabIndex(
    //     '#navigation-toggle',
    //     '#navigation-primary',
    //     'navigation-primary--active',
    //     960
    // );

    // Filter showHide
    mNav(
        '#filter-trigger',
        'filter__heading--open',
        '#filter-reveal',
        'filter__reveal--open'
    );


	gettingHereMaps();

    // // Search showHide
    // mNav(
    //     '#header-search-toggle',
    //     'header-search-toggle--open',
    //     '#header-search',
    //     'header-search--open'
    // );

    // Search expand
    // searchExpand(
    //     '.js-search',
    //     '.js-search',
    //     'js-search--active'
    // );

    // Events filter
    // mNav(
    //     '.filterBlock__title',
    //     'active',
    //     '.filters__wrap',
    //     'active'
    // );

    // Set child tab index for nav
    // childTabIndex(
    //     '.filterBlock__title',
    //     '.filters__wrap',
    //     'active',
    //     780
    // );

    // social
    // setupSharing();

    // hide children after x items and show "view more" button
    // listShowHide();

    // google maps - fires on all instances of maps so handles multiples
    // googleMaps();

    // removes the novalidate attribute on comment forms to enable client side validation
    // removeNovalidate();

    // share url
    // shareURL('.shareURL');

    // Show and hide lunch
	showHideLunch();

	// Refresh opening times
	openingTimes();

	// Show messages
	showMessages();

	// Story timeline
	storyTimeline();

	// Initialise Slick Carousels
	slickCarousel('.gallery--slick');

	// Date picker
	datePicker('#pikaday');
}

$(function run () {
    console.log('ᕕ( ᐛ )ᕗ Running...');
    globals();
});


/* old app.js content

// Create our only global object with the project namespace
var bristol_museums = bristol_museums || {};

// debounce plugin
(function(e){e.extend({debounce:function(e,t,n,r){if(arguments.length==3&&typeof n!="boolean"){r=n;n=false}var i;return function(){var s=arguments;r=r||this;n&&!i&&e.apply(r,s);clearTimeout(i);i=setTimeout(function(){!n&&e.apply(r,s);i=null},t)}},throttle:function(e,t,n){var r,i,s;return function(){i=arguments;s=true;n=n||this;if(!r){(function(){if(s){e.apply(n,i);s=false;r=setTimeout(arguments.callee,t)}else{r=null}})()}}}})})(jQuery)

// Setup nav toggle in small screen view
	bristol_museums.setupNavToggle = function() {

		var navOpen = false;

		// get the button
		var button =  $('#nav-open-btn, #nav-close-btn');
		button.on('click', toggleNav);

		function toggleNav(e) {
			e.preventDefault();
			$('html').toggleClass('js-nav');
		}
	};

// Setup meganav hoverintent

	bristol_museums.setupMegaNav = function() {
		$.root.hoverIntent(
		function() {
			$(this).toggleClass('navigation__menu--hoverintent');
			},
			'.navigation__menu'
		);
	}

// Take the image attibute off the Hero and load it as a background image. See front-page.php for the PHP side of things.

	bristol_museums.loadHeroImage = function() {
		if($(window).width() <= 600){
		// console.log('less or equal to than 600');
		var $img_src = $('#hero').data('hero-image-source-small');
	} else {
		// console.log('larger than 600');
		var $img_src = $('#hero').data('hero-image-source-large');
	}
	$('#hero').css('background-image', 'url('+$img_src+')');
};

// Sidebar mobile nav

	bristol_museums.sidebarNav = function() {
		$('.highlight__trigger').on('click', function(e) {
			e.preventDefault();
			$(this).toggleClass('highlight__trigger--active');
			$('.navigation-sidebar').toggleClass('navigation-sidebar--active');
		});
	};

// Getting here maps stuff


// 	bristol_museums.gettingHereMaps = function() {

// 		if ('undefined' != typeof(getting_there_methods)) {
// 			var responsive_tabs = $.root.find('#responsive-tabs');
// 			if (typeof base_url !== 'undefined') {
// 				var map_marker_base_url = base_url+"patterns/public/assets/img/map-ico/";
// 			} else {
// 				var map_marker_base_url = "/assets/img/map-ico/";
// 			}

// 			var active_tab = responsive_tabs.find('.resp-tab-active > a').attr('href').replace(/#/, '');
// 			loadMapFor(active_tab);

// 			responsive_tabs.on('click', '.tab__item > a', function() {
// 				loadMapFor($(this).attr('href').replace(/#/, ''));
// 			});

// 			function loadMapFor(method_stub) {

// 				var map_canvas = responsive_tabs.find('#map-canvas-'+method_stub);

// 				if (map_canvas.hasClass('js-map-loaded')) {
// 					return;
// 				}

// 			//don't load map on mobile where canvas isn't visible
// 			if (!map_canvas.parent().is(':visible')) {
// 				return;
// 			}

// 			map_canvas.addClass('js-map-loaded');

// 			var this_getting_there_method = getting_there_methods[method_stub];

// 			var map;
// 			var venue_lat_lng = new google.maps.LatLng( this_getting_there_method.venue_lat, this_getting_there_method.venue_lng );
// 			var map_center_lat_lng = new google.maps.LatLng( this_getting_there_method.center_lat, this_getting_there_method.center_lng );
// 			var mapOptions = {
// 				zoom: this_getting_there_method.zoom,
// 				center: map_center_lat_lng,
// 				scrollwheel: false,
// 				mapTypeControl: false,
// 				streetViewControl: false,
// 				panControl: true,
// 				mapTypeId: this_getting_there_method.map_type
// 			};
// 			map = new google.maps.Map(map_canvas[0], mapOptions);

// 			//venue marker
// 			var marker = false,
// 			marker_lat_lng = false,
// 			marker_icon = '';
// 			marker = new google.maps.Marker({
// 				position: venue_lat_lng,
// 				map: map,
// 				title: this_getting_there_method.venue_name,
// 				icon: map_marker_base_url + this_getting_there_method.venue_internal_slug+".png"
// 			});

// 			//transport location markers
// 			for (var i=0; i<this_getting_there_method.markers.length; i++) {
// 				marker_lat_lng = new google.maps.LatLng(this_getting_there_method.markers[i].lat,
// 														this_getting_there_method.markers[i].lng);

// 				if ('auto' == this_getting_there_method.markers[i].marker_icon) {
// 					if ('by-car' == this_getting_there_method.method_stub) {
// 						marker_icon = 'parking';
// 					}
// 					else {
// 						marker_icon = this_getting_there_method.method_stub;
// 					}
// 				}
// 				else {
// 					marker_icon = this_getting_there_method.markers[i].marker_icon;
// 				}

// 				marker_icon = map_marker_base_url + marker_icon + '.png';

// 				marker = new google.maps.Marker({
// 					position: marker_lat_lng,
// 					map: map,
// 					title: this_getting_there_method.markers[i].marker_title,
// 					icon: marker_icon
// 				});
// 			}
// 		}

// 		$(window).on('resize', function () {
// 			var active_tab = responsive_tabs.find('.resp-tab-active > a').attr('href').replace(/#/, '');
// 			loadMapFor(active_tab);
// 		});
// 	}
// };

//
// Bristol Museums — "Getting Here" tab maps.
//
// Renders a Google Map for whichever transport-method tab is active,
// lazily loading each map the first time its tab becomes visible, and
// re-centering/resizing maps on window resize instead of recreating them.
//
// Expects a global `getting_there_methods` object keyed by method_stub, e.g.
// {
//   'by-foot': {
//     venue_lat, venue_lng, venue_name, venue_internal_slug,
//     center_lat, center_lng, zoom, map_type, method_stub,
//     markers: [{ lat, lng, marker_title, marker_icon }]
//   },
//   ...
// }
///
bristol_museums.gettingHereMaps = function () {

	if (typeof getting_there_methods === 'undefined') {
		return;
	}

	var $tabs = $.root.find('#getting-here-tabs');
	var mapMarkerBaseUrl = (typeof base_url !== 'undefined')
		? base_url + 'patterns/public/assets/img/map-ico/'
		: '/assets/img/map-ico/';

	// method_stub -> { map, markers: [google.maps.Marker, ...] }
	var loadedMaps = {};

	// Resolve the icon filename for a transport marker.
	function resolveMarkerIconUrl(methodConfig, markerConfig) {
		var iconName = markerConfig.marker_icon;

		if (iconName === 'auto') {
			iconName = (methodConfig.method_stub === 'by-car')
				? 'parking'
				: methodConfig.method_stub;
		}

		return mapMarkerBaseUrl + iconName + '.png';
	}

	// Build (once) the Google Map, venue marker, and transport markers for a given method_stub.
	function buildMap(methodStub, methodConfig, $canvas) {
		var venueLatLng = new google.maps.LatLng(methodConfig.venue_lat, methodConfig.venue_lng);
		var centerLatLng = new google.maps.LatLng(methodConfig.center_lat, methodConfig.center_lng);

		var map = new google.maps.Map($canvas[0], {
			zoom: methodConfig.zoom,
			center: centerLatLng,
			scrollwheel: false,
			mapTypeControl: false,
			streetViewControl: false,
			panControl: true,
			mapTypeId: methodConfig.map_type
		});

		var markers = [];

		// Venue marker.
		markers.push(new google.maps.Marker({
			position: venueLatLng,
			map: map,
			title: methodConfig.venue_name,
			icon: mapMarkerBaseUrl + methodConfig.venue_internal_slug + '.png'
		}));

		// Transport location markers.
		var transportMarkers = methodConfig.markers || [];
		for (var i = 0; i < transportMarkers.length; i++) {
			var markerConfig = transportMarkers[i];
			var markerLatLng = new google.maps.LatLng(markerConfig.lat, markerConfig.lng);

			markers.push(new google.maps.Marker({
				position: markerLatLng,
				map: map,
				title: markerConfig.marker_title,
				icon: resolveMarkerIconUrl(methodConfig, markerConfig)
			}));
		}

		loadedMaps[methodStub] = {
			map: map,
			center: centerLatLng
		};

		// Force Maps to re-measure the container now that it's actually laid out,
	    // otherwise the first-built map (the initially active tab) can end up
	    // sized/tiled against a stale or zero-size container.
	    google.maps.event.addListenerOnce(map, 'idle', function () {
	        google.maps.event.trigger(map, 'resize');
	        map.setCenter(centerLatLng);
	    });
	}

	// Load (first time) or refresh (subsequent times) the map for a tab.
	function loadMapFor(methodStub, lastSeenHeight, attemptsLeft) {
		var methodConfig = getting_there_methods[methodStub];
		if (!methodConfig) {
			return;
		}

		var $canvas = $tabs.find('#map-canvas-' + methodStub);

		if (!$canvas.length) {
			return;
		}

		var existing = loadedMaps[methodStub];

		if (!existing) {
			// Building a Google Map inside a container that isn't at its
			// final size yet (e.g. zero-size before layout has settled)
			// leaves it permanently blank; triggering 'resize' afterwards
			// doesn't recover it. So wait for the container's size to stop
			// changing before constructing the map, instead of building
			// then fixing.
			//
			// .tab__map's height comes from the padding-bottom aspect-ratio
			// technique (see the ratio() mixin in _mixins.scss), so jQuery's
			// box-model-aware .height()/.width() (which exclude padding)
			// always read 0 here — use the element's actual rendered box
			// (offsetWidth/offsetHeight) instead.
			var canvasEl = $canvas[0];
			var currentHeight = canvasEl.offsetHeight;

			if (typeof attemptsLeft === 'undefined') {
				attemptsLeft = 40;
			}

			if (!canvasEl.offsetWidth || !currentHeight || currentHeight !== lastSeenHeight) {
				if (attemptsLeft > 0) {
					setTimeout(function () {
						loadMapFor(methodStub, currentHeight, attemptsLeft - 1);
					}, 50);
				}
				return;
			}

			buildMap(methodStub, methodConfig, $canvas);
			return;
		}

		// Already built: just make sure it re-renders correctly (e.g. after
		// being hidden/shown or the window resizing) instead of rebuilding.
		google.maps.event.trigger(existing.map, 'resize');
		existing.map.setCenter(existing.center);
	}

	function getActiveMethodStub() {
		var $checkedInput = $tabs.find('.tabs__input:checked');
		if (!$checkedInput.length) {
			return null;
		}
		return $checkedInput.val();
	}

	function debounce(fn, waitMs) {
		var timeoutId;
		return function () {
			var context = this, args = arguments;
			clearTimeout(timeoutId);
			timeoutId = setTimeout(function () {
				fn.apply(context, args);
			}, waitMs);
		};
	}

	// Load the map for whichever tab starts active.
	var initialStub = getActiveMethodStub();
	if (initialStub) {
		loadMapFor(initialStub);
	}

	// Load/refresh the map when a tab is selected. The tabs themselves are
	// pure CSS (radio inputs + :checked) — this only lazily loads each map
	// the first time its tab becomes active.
	$tabs.on('change', '.tabs__input', function () {
		loadMapFor(this.value);
	});

	// Refresh the currently active map on resize (debounced).
	$(window).on('resize', debounce(function () {
		var activeStub = getActiveMethodStub();
		if (activeStub) {
			loadMapFor(activeStub);
		}
	}, 200));
};


// Event filters

	bristol_museums.eventFilters = function() {
		var events_filter = $.root.find('.filter--events');

		if (events_filter.length) {

			events_filter.on('click', '.filter__tab__link', function(e) {
				e.preventDefault();

				$(this).closest('.filter__group').find('.filter__options--js').toggleClass('filter__options--show');
			});

		// event types
		events_filter.on('click', '.filter__option--event-type', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--event-type--([a-z\-]+)/),
			term_slug = '';

			if (term_slug = matches[1]) {
				events_filter.find('input[name="event-type"]').prop('checked', false);
				events_filter.find('input[name="event-type"][value="'+term_slug+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});

		// learning types
		events_filter.on('click', '.filter__option--learning-type', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--learning-type--([a-z\-]+)/),
			term_slug = '';

			if (term_slug = matches[1]) {
				events_filter.find('input[name="learning-type"]').prop('checked', false);
				events_filter.find('input[name="learning-type"][value="'+term_slug+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});

		// school years
		events_filter.on('click', '.filter__option--school-years', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--school-years--([a-z0-9\-]+)/),
			term_slug = '';

			if (term_slug = matches[1]) {
				events_filter.find('input[name="school-years"]').prop('checked', false);
				events_filter.find('input[name="school-years"][value="'+term_slug+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});

		// subjects
		events_filter.on('click', '.filter__option--subjects', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--subjects--([a-z0-9\-]+)/),
			term_slug = '';

			if (term_slug = matches[1]) {
				events_filter.find('input[name="subjects"]').prop('checked', false);
				events_filter.find('input[name="subjects"][value="'+term_slug+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});

		// date span
		events_filter.on('click', '.filter__option--date-span', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--date-span--([a-z0-9\-]+)/),
			date_span = '';

			if (date_span = matches[1]) {
				events_filter.find('input[name="event-date-span"]').prop('checked', false);
				events_filter.find('input[name="event-date-span"][value="'+date_span+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});

		// venues
		events_filter.on('click', '.filter__option--all-venues', function(e) {
			e.preventDefault();

			events_filter.find('input[name="event-location"]').prop('checked', false);

			events_filter.trigger('submit');
		});

		events_filter.on('click', '.filter__option--logo', function(e) {
			e.preventDefault();

			var matches = $(this).attr('class').match(/filter__option--logo--([a-z\-]+)/),
			venue_slug = '';

			if (venue_slug = matches[1]) {
				events_filter.find('input[name="event-location"]').prop('checked', false);
				events_filter.find('input[name="event-location"][value="'+venue_slug+'"]').prop('checked', true);
				events_filter.trigger('submit');
			}
		});
	}
};


// Venue hire

	bristol_museums.venueHire = function() {
		var venueHireSubnav = $.root.find('.venue-hire__subnav');

		if (venueHireSubnav.length) {
			$(window).on('resize', $.debounce(positionVenueHireSubnav, 500));
			positionVenueHireSubnav();
		}

		function positionVenueHireSubnav() {
			var subnavContainerAfterContent = $.root.find('.venue-hire__subnav-container--after-content'),
			subnavContainerSidebar = $.root.find('.venue-hire__subnav-container--sidebar');

			if (subnavContainerAfterContent.length && subnavContainerSidebar.length) {
				if(subnavContainerAfterContent.is(':visible')) {
					venueHireSubnav.appendTo(subnavContainerAfterContent);
				}
				else {
					venueHireSubnav.appendTo(subnavContainerSidebar);
				}
			}
		}
	};

// Slick carousels

	bristol_museums.slickCarousels = function() {
		$('.gallery--slick').slick({
			dots: true,
			lazyLoad: 'ondemand'
		});
	};


// Show hide lunch on the learning enquiry forms


	bristol_museums.showHideLunch = function(){
		var $lunch = $('#lunch');
		var $museum = $('#cfMuseum');
		if($museum.val() == 'm-shed' || $museum.val() == 'bristol-museum-and-art-gallery'){
			$lunch.show();
		} else {
			$lunch.hide();
		}
		$museum.on('change', function(e) {
			e.preventDefault();
			if($museum.val() == 'm-shed' || $museum.val() == 'bristol-museum-and-art-gallery' || $museum.val() == ''){
				$lunch.show();
			} else {
				$lunch.hide();
			}
		});
	}

// Show messages


	bristol_museums.setupMessages = function() {
		// Check cookie
		var alert_cookie = bristol_museums.getCookie('alert_cookie');
		if(alert_cookie != 1){
			$('#alert-message__wrapper').css('display', 'block');
			$('#alert-message__wrapper').slideDown(300);
		}

		$('#alert-message__close').on('click', function(e) {
			e.preventDefault();
			$('#alert-message__wrapper').slideUp(300, function(){
				$(this).remove();
			});
			bristol_museums.setCookie('alert_cookie',1,0);
		});
	};

// Cookie management


	bristol_museums.setCookie = function(key, value, expiry=0) { // Expiry in minutes
		var now = new Date();
		var time = now.getTime();
		time += expiry * 60 * 1000;
		now.setTime(time);
		expiry = now.toUTCString();
		console.log(expiry);
		document.cookie = key + '=' + value + ';expires='+ expiry +';path=/;';
	}

	bristol_museums.getCookie = function(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}

	bristol_museums.removeCookie = function(key) {
		document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
	}

// Opening times


	bristol_museums.openingTimes = function() {
		var $el = $('.js-opening-times');
		var id  = $el.attr('data-post');
		var time_travel_date = null;
		var time_travel_time = null;

		if ($('.admin-time-travel').length) {
			time_travel_date = $('#admin-time-travel_field--date').val() || null;
			time_travel_time = time_travel_date ? $('#admin-time-travel_field--time').val() : null;
		}

		function refresh () {
			$.ajax({
				url: '/wp/wp-admin/admin-ajax.php',
				type: 'post',
				data: {
					action: 'opening_times_ajax',
					post_id: id,
					"time-travel-date": time_travel_date,
					"time-travel-time": time_travel_time
				},
				success: function (html) {
					$el.html(html);
					$el.closest('.hero__opening-times')
					.hide()
					.fadeIn();
				},
				error: function() {
				// What do?
			}
		});
		}

		if($el.length){
			refresh();
			setTimeout(refresh, 300000);
		}
	};

// Google Analytics extras

	bristol_museums.gAnalytics = function () {

		function query (str) {
			var vars = {}, hash;
			var q = str.split('?')[1];
			if (q != undefined) {
				q = q.split('&');
				for (var i = 0; i < q.length; i++) {
					hash = q[i].split('=');
					vars[hash[0]] = hash[1];
				}
			}
			return vars;
		}

		var queryobj = query(window.location.href);
		var eventSent = false;

		if ('_gaq' in window) {

		// Event type filter
		if ('event-type' in queryobj) {
			_gaq.push(['_trackEvent', 'What\'s on', 'Event type filter', queryobj['event-type']]);
		}

		// On contact form submission
		$('form:not(.filter)').on('submit', function (e) {
			$form = $(this);
			var $enquiryType = $form.find('select[name="category"]');

			if ($enquiryType.length && !eventSent) {
				eventSent = true;
				_gaq.push(['_trackEvent', 'Enquiry form', 'Enquiry type', $enquiryType.val()]);
			}
		});

	}
};

// Setup and run the Slick Carousel
	bristol_museums.setupCarousel = function() {
		$('.carousel').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: true,
			dots: true
		});
	};

// Stories timeline
	bristol_museums.setupTimeline = function() {

	// store vars for toggling
	var hideClass = 'js-timeline__item--hidden';
	var hideAria = 'aria-hidden';

	$.root.find('.js-timeline').each(function(index) {
		var closed = true;
		var minItems = $(this).data('min-items');
		var items = $(this).find('.js-timeline__item').slice(minItems);
		var button = $(this).find('.js-timeline__button');
		var links = $(this).find('.js-timeline__content a');

		// add toggle handler
		button.on('click', function() {

			var labelMore = $(this).data('label-more');
			var labelFewer = $(this).data('label-fewer');

			// toggle open and closed
			if (closed) {
				closed = false;
				$(this)
				.text(labelFewer);
				items
				.removeClass(hideClass)
				.removeAttr(hideAria);
			}
			else {
				// calc offset to jump back to button position
				var offset = this.getBoundingClientRect().top;
				closed = true;
				$(this)
				.text(labelMore);
				items
				.addClass(hideClass)
				.attr(hideAria, true);
				$('html, body')
				.scrollTop($(this).offset().top - offset);
			}
		});

		// add handler for content links
		links.on('click', function(e) {
			e.preventDefault();
			var id = $(this).closest('.js-timeline__item').attr('id');
			history.pushState({ timelineId: id }, 'Timeline item');
			window.location = this.href;
		});

		// check for existing history state
		if (history.state && history.state.timelineId) {
			// check for matching item
			var item = $(this).find('#' + history.state.timelineId);
			if (item.length) {
				// clear the history state and scroll to top of matched item
				history.pushState(null, 'Timeline item');
				button.trigger('click');
				$('html, body')
				.scrollTop($(item).offset().top);
			}
		};

	});
};

bristol_museums.showHide = function(trigger, triggerActive, target, targetActive){
	$(trigger).on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass(triggerActive);
		$(target).toggleClass(targetActive);
	});
}

bristol_museums.datepicker = function(){

	// Change date field to text to prevent native browser date functionality displaying
	$('#pikaday').attr("type","text");

	var picker = new Pikaday({
		field: $('#pikaday')[0],
		format: 'D/M/YYYY',
		toString(date, format) {
			// you should do formatting based on the passed format,
			// but we will just return 'D/M/YYYY' for simplicity
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			return `${day}/${month}/${year}`;
		},
		parse(dateString, format) {
			// dateString is the result of `toString` method
			const parts = dateString.split('/');
			const day = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1;
			const year = parseInt(parts[2], 10);
			return new Date(year, month, day);
		}
	});
}

bristol_museums.init = function() {

	$.root = $(document.body);

	//nav
	bristol_museums.setupNavToggle();

	//meganav hoverintent
	bristol_museums.setupMegaNav();

	bristol_museums.sidebarNav();

	// Hero image
	bristol_museums.loadHeroImage();

	// Getting here maps. The tabs themselves are pure CSS (radio inputs +
	// :checked) and need no JS to switch. This is deferred to window 'load'
	// (rather than run inline here, at DOMContentLoaded) so the tab layout
	// has fully settled — building a Google Map against a container that
	// isn't at its final size yet leaves it permanently blank.
	$(window).on('load', function () {
		bristol_museums.gettingHereMaps();
	});

	bristol_museums.eventFilters();

	bristol_museums.venueHire();

	bristol_museums.slickCarousels();

	// Show and hide lunch
	bristol_museums.showHideLunch();

	// Message system
	bristol_museums.setupMessages();

	// Refresh opening times
	bristol_museums.openingTimes();

	// Google analytics extras
	bristol_museums.gAnalytics();

	// Stories
	// bristol_museums.setupGallery();
	bristol_museums.setupCarousel();
	bristol_museums.setupTimeline();

	// Filter stuff
	bristol_museums.showHide(
		'#filter-trigger',
		'filter__heading--open',
		'#filter-reveal',
		'filter__reveal--open'
		);

	// Date picker
	bristol_museums.datepicker();
};

 $(function() {
	bristol_museums.init();
 });


*/